module.exports = __webpack_public_path__ + "static/media/uta-logo.47cf76c1.png";